import { LoanModel } from "providers/loans/loan.model";

export abstract class LoanHelper {
	public static groupByFieldLabel(
		loans: LoanModel[],
		fieldLabel: string
	): Map<string, LoanModel[]> {
		return loans.reduce((grouped, loan) => {
			const lienLoanTypeValue = loan.values.find(
				(field) => field.loan_field.label.toLocaleLowerCase() === fieldLabel
			)?.value?.field;

			if (!lienLoanTypeValue) {
				return grouped;
			}

			if (!grouped.has(lienLoanTypeValue)) {
				grouped.set(lienLoanTypeValue, []);
			}
			grouped.get(lienLoanTypeValue)!.push(loan);

			return grouped;
		}, new Map<string, LoanModel[]>());
	}
}
